import Parse from "parse";

import type { Project } from "./Project";
import type { Ticket } from "./Ticket";
import type { _User } from "./_User";

type OD3_Tenant = Parse.Object;

export interface Ticket_ProjectAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;

  project?: Project;
  tenant?: OD3_Tenant;
  ticket?: Ticket;
  user?: _User;
}

export class Ticket_Project extends Parse.Object<Ticket_ProjectAttributes> {
  static className: string = "OD3_Maintenance_Ticket_Project";

  constructor(data?: Partial<Ticket_ProjectAttributes>) {
    super("OD3_Maintenance_Ticket_Project", data as Ticket_ProjectAttributes);
  }

  get project(): Project | undefined {
    return super.get("project");
  }
  set project(value: Project | undefined) {
    super.set("project", value);
  }
  get tenant(): OD3_Tenant | undefined {
    return super.get("tenant");
  }
  set tenant(value: OD3_Tenant | undefined) {
    super.set("tenant", value);
  }
  get ticket(): Ticket | undefined {
    return super.get("ticket");
  }
  set ticket(value: Ticket | undefined) {
    super.set("ticket", value);
  }
  get user(): _User | undefined {
    return super.get("user");
  }
  set user(value: _User | undefined) {
    super.set("user", value);
  }
}

Parse.Object.registerSubclass("OD3_Maintenance_Ticket_Project", Ticket_Project);
